























import { Component, Vue } from 'vue-property-decorator'
import QRcode from '@/components/QRcode/index.vue'
import { mchUserLogo } from '@/api/com'
import { userLogo } from '../types'
import { UserStore } from '@/store/modules/User'
import { httpsImg } from '@/utils/tool'

@Component({
  name: 'Merchant',
  components: {
    QRcode
  }
})
export default class Merchant extends Vue {
  // 我要上推荐
  private show = false

  // 推荐商户
  private mchUserLogoList: any[] = [];

  private httpsImg = httpsImg

  // 获取 推荐商户
  private getMchUserLogo (): void {
    const params = {
      page: 1,
      resultNum: 20,
      parentMchId: UserStore.userInfo.parentMchId
    }
    mchUserLogo(params)
      .then((res: any) => {
        if (res) {
          this.mchUserLogoList = res
        }
      })
  }

  // 点击某一个商户
  private clickItem (item: userLogo): void {
    this.$router.push(`/business/merchant/${item.dbLink}/${item.parentMchId}`)
  }

  mounted (): void {
    this.getMchUserLogo()
  }
}
